export { GET_NEXT_PAGE } from './getNextPage';

